import { capitalize } from 'lodash';

/**
 * Capitalizes the first letter of a string dynamically.
 * Returns empty string if input is null/undefined.
 */
export function capitalizeFirst(str?: string): string {
  if (!str) return '';
  return capitalize(str);
}
